var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    id: "focusicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12,17c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S14.757,17,12,17z M12,8c-2.206,0-4,1.794-4,4s1.794,4,4,4 s4-1.794,4-4S14.206,8,12,8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.5,6C23.224,6,23,5.776,23,5.5V3h-2.5C20.224,3,20,2.776,20,2.5S20.224,2,20.5,2h3C23.776,2,24,2.224,24,2.5v3 C24,5.776,23.776,6,23.5,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.5,22h-3c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5H23v-2.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v3 C24,21.776,23.776,22,23.5,22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0.5,6C0.224,6,0,5.776,0,5.5v-3C0,2.224,0.224,2,0.5,2h3C3.776,2,4,2.224,4,2.5S3.776,3,3.5,3H1v2.5 C1,5.776,0.776,6,0.5,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5,22h-3C0.224,22,0,21.776,0,21.5v-3C0,18.224,0.224,18,0.5,18S1,18.224,1,18.5V21h2.5C3.776,21,4,21.224,4,21.5 S3.776,22,3.5,22z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusIcon);
export default __webpack_public_path__ + "static/media/focus-icon.a49a41016d09624b6c8c3f8c51a23065.svg";
export { ForwardRef as ReactComponent };